import { __assign, __read, __rest, __spread, __values } from "tslib";
import React, { createContext, useRef, useState, forwardRef, useContext, } from "react";
import { getElementOffset } from "../../../_util/get-element-offset";
import { mergeRefs } from "../../../_util/merge-refs";
import { now } from "../../../_util/now";
import { deepCopy } from "../../../_util/deep-copy";
import { useConfig } from "../../../util";
var hoverTimeInfos = {
    id: "",
    startTime: 0,
};
var tdPaddingLeft;
var insertLineHandler = 0;
var dragElementWidthFromCursorToHead = 0;
var dragRecord = {};
/**
 * 拖拽 Context 实例
 */
export var RowsDragContext = createContext({});
RowsDragContext.displayName = "RowsDragContext";
export function RowsDraggableTable(_a) {
    var table = _a.table, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, relations = _a.relations, indent = _a.indent, onExpandedKeysChange = _a.onExpandedKeysChange, expandedKeys = _a.expandedKeys, recordsData = _a.recordsData, getRowKey = _a.getRowKey, dragType = _a.dragType, childrenColName = _a.childrenColName, iconColumnWidth = _a.iconColumnWidth, props = __rest(_a, ["table", "onDragEnd", "onDragStart", "relations", "indent", "onExpandedKeysChange", "expandedKeys", "recordsData", "getRowKey", "dragType", "childrenColName", "iconColumnWidth"]);
    var _b = __read(useState(""), 2), draggingRowKey = _b[0], setDraggingRowKey = _b[1];
    var _c = __read(useState({}), 2), dragInfos = _c[0], setDragInfos = _c[1];
    var bodyRef = useRef(null);
    var bodyLineRef = useRef(null);
    /**
     * 获取行的树深度 & paddingLeft
     * @param rowKey 行ID
     * @returns
     */
    var getDepthAndPaddingLeft = function (rowKey) {
        var paddingLeft = 0;
        var depth = 0;
        if (indent > 0) {
            var node = rowKey;
            while (relations && relations[node]) {
                depth += 1;
                node = relations[node];
            }
            paddingLeft = indent * depth;
        }
        return { paddingLeft: paddingLeft, depth: depth };
    };
    /**
     * 绘制插入线
     */
    var drawInsertLine = function (width, left, top) {
        if (insertLineHandler) {
            cancelAnimationFrame(insertLineHandler);
        }
        insertLineHandler = requestAnimationFrame(function () {
            bodyLineRef.current.style.display = "block";
            bodyLineRef.current.style.width = width + "px";
            bodyLineRef.current.style.transform = "translate3d(" + (left +
                iconColumnWidth) + "px, " + top + "px, 0px)";
            bodyLineRef.current.style.pointerEvents = "none";
        });
    };
    /**
     * 重建树
     * @param dragKey 拖拽排序的原行key
     * @param baseKey 拖拽到基准目标行的key
     * @param depth 插入的树的深度
     * @param records 表格数据
     */
    var rebuildTree = function (dragKey, baseKey, depth, records) {
        var subtree;
        var baseKeyIndex;
        var subtreeIndex;
        var operateSubtreeDataLoop = function (key, records, type) {
            if (!records || !Array.isArray(records)) {
                return;
            }
            /* eslint-disable */
            for (var index in records) {
                var isMatch = !!(records[index] &&
                    getRowKey(records[index], parseInt(index, 10)) === key);
                var isGetSubtreeAndMatch = isMatch && type === "getAndRemoveSubtree";
                if (isGetSubtreeAndMatch) {
                    subtree = records[index];
                    subtreeIndex = index;
                    records.splice(parseInt(index, 10), 1);
                    dragRecord = {
                        record: deepCopy(subtree),
                        index: parseInt(index, 10),
                    };
                    break;
                }
                var isGetBaseKeyIndexAndMatch = isMatch && type === "getBaseKeyIndex";
                if (isGetBaseKeyIndexAndMatch) {
                    baseKeyIndex = parseInt(index, 10);
                    break;
                }
                var isAddSubtree = isMatch && type === "addSubtree";
                if (isAddSubtree &&
                    typeof baseKeyIndex !== "undefined" &&
                    records[index] &&
                    subtree) {
                    if (records[index][childrenColName] &&
                        Array.isArray(records[index][childrenColName])) {
                        records[index][childrenColName].splice(parseInt(baseKeyIndex, 10), 0, subtree);
                    }
                    else {
                        records[index][childrenColName] = [subtree];
                    }
                    break;
                }
                if (records[index] &&
                    records[index][childrenColName] &&
                    Array.isArray(records[index][childrenColName])) {
                    operateSubtreeDataLoop(key, records[index][childrenColName], type);
                }
            }
        };
        // 获取baseKeyIndex
        if (baseKey) {
            operateSubtreeDataLoop(baseKey, records, "getBaseKeyIndex");
        }
        // 获取并从原树中删除子树
        operateSubtreeDataLoop(dragKey, records, "getAndRemoveSubtree");
        var addSubtree = function (baseKey, depth, records) {
            var baseKeyDepth = getDepthAndPaddingLeft(baseKey).depth;
            var parentKey = relations && typeof relations[baseKey] !== "undefined"
                ? relations[baseKey]
                : null;
            // 插入首行
            if (baseKey === "") {
                records.splice(0, 0, subtree);
            }
            if ((!baseKeyIndex && baseKeyIndex !== 0) || !subtree) {
                return;
            }
            // 深度为0插入根节点
            if (depth === 0) {
                var nodeKey_1 = baseKey;
                while (relations && relations[nodeKey_1]) {
                    nodeKey_1 = relations[nodeKey_1];
                }
                var baseKeyParentIndex = records.findIndex(function (record, index) { return getRowKey(record, index) === nodeKey_1; });
                records.splice(baseKeyParentIndex + 1, 0, subtree);
                return;
            }
            // 为基准节点的兄弟节点
            if (depth === baseKeyDepth) {
                // 判断摘除的子节点是否是和base节点是兄弟节点
                if (relations[dragKey] !== relations[baseKey]) {
                    baseKeyIndex += 1;
                }
                if (relations[dragKey] &&
                    relations[baseKey] &&
                    relations[dragKey] === relations[baseKey] &&
                    subtreeIndex > baseKeyIndex) {
                    baseKeyIndex += 1;
                }
                operateSubtreeDataLoop(parentKey, records, "addSubtree");
                return;
            }
            // 为基准节点的子节点
            if (depth > baseKeyDepth) {
                baseKeyIndex = 0;
                operateSubtreeDataLoop(baseKey, records, "addSubtree");
                return;
            }
            // 为基准节点的父节点的兄弟节点
            if (depth < baseKeyDepth) {
                var len = baseKeyDepth - depth + 1;
                var nodeKey = baseKey;
                while (len > 0) {
                    nodeKey = relations[nodeKey];
                    len -= 1;
                    // 更新下baseKeyIndex
                    if (len === 1) {
                        operateSubtreeDataLoop(nodeKey, records, "getBaseKeyIndex");
                        baseKeyIndex += 1;
                    }
                }
                operateSubtreeDataLoop(nodeKey, records, "addSubtree");
            }
        };
        // 添加子树
        addSubtree(baseKey, depth, records);
        var cleanEmptyTreeNode = function (records) {
            var e_1, _a;
            try {
                for (var records_1 = __values(records), records_1_1 = records_1.next(); !records_1_1.done; records_1_1 = records_1.next()) {
                    var record = records_1_1.value;
                    if (record[childrenColName] &&
                        Array.isArray(record[childrenColName]) &&
                        record[childrenColName].length > 0) {
                        cleanEmptyTreeNode(record[childrenColName]);
                    }
                    if (record[childrenColName] &&
                        Array.isArray(record[childrenColName]) &&
                        record[childrenColName].length === 0) {
                        delete record[childrenColName];
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (records_1_1 && !records_1_1.done && (_a = records_1.return)) _a.call(records_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        // 清除空数组属性
        cleanEmptyTreeNode(records);
    };
    var rebuildRow = function (dragKey, baseKey, depth, records) {
        if (dragKey === baseKey) {
            return;
        }
        var dragKeyIndex;
        var baseKeyIndex;
        /* eslint-disable */
        for (var index in records) {
            if (records[index] &&
                getRowKey(records[index], parseInt(index, 10)) === dragKey) {
                dragKeyIndex = parseInt(index, 10);
            }
            if (records[index] &&
                getRowKey(records[index], parseInt(index, 10)) === baseKey) {
                baseKeyIndex = parseInt(index, 10);
            }
        }
        if (!baseKey) {
            records.splice(0, 0, records.splice(dragKeyIndex, 1)[0]);
        }
        else {
            if (baseKeyIndex < dragKeyIndex) {
                baseKeyIndex += 1;
            }
            var row = records.splice(dragKeyIndex, 1)[0];
            records.splice(baseKeyIndex, 0, row);
            dragRecord = { record: deepCopy(row), index: parseInt(dragKeyIndex, 10) };
        }
    };
    var dragEventHandlers = {
        onDragStart: function (event) {
            event.stopPropagation();
            // QQ 浏览器设置 text 不触发 drop
            // event.dataTransfer.setData("text", "text");
            event.dataTransfer.setData("image/png", "img");
            event.dataTransfer.effectAllowed = "move";
            var draggingRowKey = event.currentTarget.attributes.getNamedItem("data-key").value;
            // 获取光标到被拖元素头部距离
            var dragElementProperties = getElementOffset(event.currentTarget);
            dragElementWidthFromCursorToHead =
                event.clientX - dragElementProperties.left;
            dragElementWidthFromCursorToHead =
                dragElementWidthFromCursorToHead < 0
                    ? 0
                    : dragElementWidthFromCursorToHead;
            if (typeof tdPaddingLeft === "undefined") {
                var firstTdNode = event.currentTarget.firstChild;
                tdPaddingLeft =
                    typeof window.getComputedStyle !== "undefined"
                        ? parseInt(window
                            .getComputedStyle(firstTdNode, null)
                            .getPropertyValue("padding-left"))
                        : 0;
            }
            if (dragType === "tree" && expandedKeys) {
                var newExpandedKeys = new Set(expandedKeys);
                if (newExpandedKeys.has(draggingRowKey)) {
                    newExpandedKeys.delete(draggingRowKey);
                    onExpandedKeysChange(__spread(newExpandedKeys));
                }
            }
            setDragInfos({});
            setDraggingRowKey(draggingRowKey);
            onDragStart({
                draggableId: draggingRowKey,
                mode: "FLUID",
                source: {
                    droppableId: "droppable",
                    index: recordsData.findIndex(function (row, index) { return getRowKey(row, index) === draggingRowKey; })
                },
                type: "DEFAULT",
            });
        },
        onDrag: function (event) {
            event.stopPropagation();
        },
        onDragEnd: function (event) {
            if (insertLineHandler) {
                cancelAnimationFrame(insertLineHandler);
            }
            bodyLineRef.current.style.display = "none";
            setDraggingRowKey("");
        },
        onDragEnter: function (event) {
            event.preventDefault();
            if (dragType === "tree") {
                hoverTimeInfos = {
                    id: event.currentTarget.attributes.getNamedItem("data-key").value,
                    startTime: now(),
                };
            }
        },
        onDragOver: function (event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = "move";
            var bodyElementProperties = getElementOffset(bodyRef.current);
            var hoverRowKey = event.currentTarget.attributes.getNamedItem("data-key").value;
            var hoverElementProperties = getElementOffset(event.currentTarget);
            var hoverElementMiddleLineYValue = hoverElementProperties.top + hoverElementProperties.height / 2;
            var previousNode = event.currentTarget.previousElementSibling;
            var nextNode = event.currentTarget.nextElementSibling;
            var dragElementHeadClientX = event.clientX - dragElementWidthFromCursorToHead;
            dragElementHeadClientX =
                dragElementHeadClientX < 0 ? 0 : dragElementHeadClientX;
            var insertDepth = 0;
            var insertLineLeft = 0;
            var insertLineTop = 0;
            var insertLineWidth = hoverElementProperties.width;
            if (dragType === "row") {
                var dropKey = "";
                // hover行是拖拽的行，无法插入
                if (draggingRowKey === hoverRowKey) {
                    bodyLineRef.current.style.display = "none";
                    return;
                }
                if (event.clientY < hoverElementMiddleLineYValue && previousNode) {
                    var previousElementProperties = getElementOffset(previousNode);
                    dropKey = previousNode.attributes.getNamedItem("data-key").value;
                    insertLineTop =
                        previousElementProperties.top -
                            bodyElementProperties.top +
                            previousElementProperties.height -
                            1;
                }
                if (event.clientY >= hoverElementMiddleLineYValue) {
                    dropKey = hoverRowKey;
                    insertLineTop =
                        hoverElementProperties.top -
                            bodyElementProperties.top +
                            hoverElementProperties.height -
                            1;
                }
                drawInsertLine(insertLineWidth, 0, insertLineTop);
                setDragInfos({
                    depth: 0,
                    dragKey: draggingRowKey,
                    dropKey: dropKey,
                });
                return;
            }
            // 如果是关闭情况需要执行展开操作
            var parentKeys = [];
            /* eslint-disable */
            for (var key in relations) {
                parentKeys.push(relations[key]);
            }
            if (hoverRowKey === hoverTimeInfos.id) {
                var spendTime = now() - hoverTimeInfos.startTime;
                if (!expandedKeys.includes(hoverRowKey) &&
                    parentKeys.includes(hoverRowKey) &&
                    spendTime >= 1000 &&
                    hoverRowKey !== draggingRowKey) {
                    var newExpandedKeys = new Set(expandedKeys);
                    newExpandedKeys.add(hoverRowKey);
                    onExpandedKeysChange(__spread(newExpandedKeys));
                }
            }
            else {
                hoverTimeInfos.id = hoverRowKey;
                hoverTimeInfos.startTime = now();
            }
            // 插入线绘制
            var _a = getDepthAndPaddingLeft(hoverRowKey), hoverElementPaddingLeft = _a.paddingLeft, hoverElementDepth = _a.depth;
            // 插入hover元素上方
            if (event.clientY < hoverElementMiddleLineYValue) {
                if (!previousNode) {
                    insertLineLeft = hoverElementPaddingLeft;
                    insertLineTop =
                        hoverElementProperties.top - bodyElementProperties.top;
                    insertDepth = 0;
                    drawInsertLine(insertLineWidth, insertLineLeft, insertLineTop);
                    setDragInfos({
                        depth: insertDepth,
                        dragKey: draggingRowKey,
                        dropKey: "",
                    });
                    return;
                }
                var previousRowKey = previousNode.attributes.getNamedItem("data-key")
                    .value;
                var _b = getDepthAndPaddingLeft(previousRowKey), previousElementPaddingLeft = _b.paddingLeft, previousElementDepth = _b.depth;
                var previousElementProperties = getElementOffset(previousNode);
                var previousElementInsertBoundaryXValue = previousElementProperties.left +
                    previousElementPaddingLeft +
                    indent * 3;
                if (draggingRowKey === previousRowKey) {
                    bodyLineRef.current.style.display = "none";
                    return;
                }
                // 上层元素是父级情况，只能插入其子级
                if (previousElementDepth < hoverElementDepth) {
                    insertLineLeft =
                        previousElementProperties.left -
                            bodyElementProperties.left +
                            previousElementPaddingLeft +
                            indent +
                            tdPaddingLeft;
                    insertLineTop =
                        previousElementProperties.top -
                            bodyElementProperties.top +
                            previousElementProperties.height -
                            1;
                    insertDepth = previousElementDepth + 1;
                    insertLineWidth -= insertLineLeft;
                    drawInsertLine(insertLineWidth, insertLineLeft, insertLineTop);
                    setDragInfos({
                        depth: insertDepth,
                        dragKey: draggingRowKey,
                        dropKey: previousRowKey,
                    });
                    return;
                }
                // 上层是同级，可以插入其同级或子级
                if (dragElementHeadClientX > previousElementInsertBoundaryXValue &&
                    previousElementDepth === hoverElementDepth) {
                    insertLineLeft =
                        previousElementProperties.left -
                            bodyElementProperties.left +
                            previousElementPaddingLeft +
                            indent +
                            tdPaddingLeft;
                    insertLineTop =
                        previousElementProperties.top -
                            bodyElementProperties.top +
                            previousElementProperties.height -
                            1;
                    insertDepth = previousElementDepth + 1;
                }
                else if (previousElementDepth > hoverElementDepth) {
                    // 上层非子级，当深度大于hover行，最终插入深度不能浅于hover行
                    var distance = previousElementInsertBoundaryXValue - dragElementHeadClientX;
                    var substractDepth = Math.floor(distance / indent);
                    insertDepth = previousElementDepth - substractDepth;
                    insertDepth =
                        insertDepth < hoverElementDepth ? hoverElementDepth : insertDepth;
                    insertDepth =
                        insertDepth > previousElementDepth
                            ? previousElementDepth + 1
                            : insertDepth;
                    insertLineLeft =
                        previousElementProperties.left -
                            bodyElementProperties.left +
                            insertDepth * indent +
                            tdPaddingLeft;
                    insertLineTop =
                        previousElementProperties.top -
                            bodyElementProperties.top +
                            previousElementProperties.height -
                            1;
                }
                else {
                    insertLineLeft =
                        previousElementProperties.left -
                            bodyElementProperties.left +
                            previousElementPaddingLeft +
                            tdPaddingLeft;
                    insertLineTop =
                        previousElementProperties.top -
                            bodyElementProperties.top +
                            previousElementProperties.height -
                            1;
                    insertDepth = previousElementDepth;
                }
                insertLineWidth -= insertLineLeft;
                drawInsertLine(insertLineWidth, insertLineLeft, insertLineTop);
                setDragInfos({
                    depth: insertDepth,
                    dragKey: draggingRowKey,
                    dropKey: previousRowKey,
                });
                return;
            }
            // 插入hover元素下方
            // hover行是拖拽的行，且为第一级（深度为0）不能操作
            if (draggingRowKey === hoverRowKey && hoverElementDepth === 0) {
                bodyLineRef.current.style.display = "none";
                return;
            }
            // 判断插入层级的clientX临界点
            var hoverElementInsertBoundaryXValue = hoverElementProperties.left + hoverElementPaddingLeft + indent * 3;
            // hover行是拖拽的行，此处可以插入其父级
            if ((draggingRowKey === hoverRowKey && hoverElementDepth > 0) ||
                !nextNode) {
                var distance = hoverElementInsertBoundaryXValue - dragElementHeadClientX;
                var substractDepth = Math.floor(distance / indent);
                insertDepth = hoverElementDepth - substractDepth;
                insertDepth = insertDepth < 0 ? 0 : insertDepth;
                insertDepth =
                    insertDepth > hoverElementDepth
                        ? !nextNode && draggingRowKey !== hoverRowKey
                            ? hoverElementDepth + 1
                            : hoverElementDepth
                        : insertDepth;
                insertLineLeft =
                    hoverElementProperties.left -
                        bodyElementProperties.left +
                        insertDepth * indent +
                        tdPaddingLeft;
                insertLineTop =
                    hoverElementProperties.top -
                        bodyElementProperties.top +
                        hoverElementProperties.height -
                        1;
                insertLineWidth -= insertLineLeft;
                drawInsertLine(insertLineWidth, insertLineLeft, insertLineTop);
                setDragInfos({
                    depth: insertDepth,
                    dragKey: draggingRowKey,
                    dropKey: hoverRowKey,
                });
                return;
            }
            var nextRowKey = nextNode.attributes.getNamedItem("data-key").value;
            var nextElementDepth = getDepthAndPaddingLeft(nextRowKey).depth;
            // hover行的下一个是子级，只能插入hover行后子级
            if (hoverElementDepth < nextElementDepth) {
                insertLineLeft =
                    hoverElementProperties.left -
                        bodyElementProperties.left +
                        hoverElementPaddingLeft +
                        indent +
                        tdPaddingLeft;
                insertLineTop =
                    hoverElementProperties.top -
                        bodyElementProperties.top +
                        hoverElementProperties.height -
                        1;
                insertDepth = hoverElementDepth + 1;
                insertLineWidth -= insertLineLeft;
                drawInsertLine(insertLineWidth, insertLineLeft, insertLineTop);
                setDragInfos({
                    depth: insertDepth,
                    dragKey: draggingRowKey,
                    dropKey: hoverRowKey,
                });
                return;
            }
            // hover行的下一个是同级或大级，插入hover行后不能超过下一级深度
            if (dragElementHeadClientX > hoverElementInsertBoundaryXValue) {
                insertLineLeft =
                    hoverElementProperties.left -
                        bodyElementProperties.left +
                        (hoverElementDepth + 1) * indent +
                        tdPaddingLeft;
                insertLineTop =
                    hoverElementProperties.top -
                        bodyElementProperties.top +
                        hoverElementProperties.height -
                        1;
                insertDepth = hoverElementDepth + 1;
            }
            else {
                var distance = hoverElementInsertBoundaryXValue - dragElementHeadClientX;
                var substractDepth = Math.floor(distance / indent);
                insertDepth = hoverElementDepth - substractDepth;
                insertDepth =
                    insertDepth < nextElementDepth ? nextElementDepth : insertDepth;
                insertLineLeft =
                    hoverElementProperties.left -
                        bodyElementProperties.left +
                        insertDepth * indent +
                        tdPaddingLeft;
                insertLineTop =
                    hoverElementProperties.top -
                        bodyElementProperties.top +
                        hoverElementProperties.height -
                        1;
            }
            insertLineWidth -= insertLineLeft;
            drawInsertLine(insertLineWidth, insertLineLeft, insertLineTop);
            setDragInfos({
                depth: insertDepth,
                dragKey: draggingRowKey,
                dropKey: hoverRowKey,
            });
        },
        onDragLeave: function (event) {
            event.preventDefault();
        },
        onDrop: function (event) {
            event.preventDefault();
            if (!draggingRowKey) {
                return;
            }
            var records = deepCopy(recordsData);
            if (dragInfos.dragKey && dragType === "tree") {
                rebuildTree(dragInfos.dragKey, dragInfos.dropKey, dragInfos.depth, records);
            }
            if (dragInfos.dragKey && dragType === "row") {
                rebuildRow(dragInfos.dragKey, dragInfos.dropKey, dragInfos.depth, records);
            }
            if (insertLineHandler) {
                cancelAnimationFrame(insertLineHandler);
            }
            bodyLineRef.current.style.display = "none";
            onDragEnd(records, {
                dragKey: dragInfos.dragKey,
                dragRecordIndex: dragRecord.index,
                dragRecord: dragRecord.record,
                dropKey: dragInfos.dropKey,
                dropDepth: dragInfos.depth,
            });
        },
    };
    var dragContext = {
        bodyRef: bodyRef,
        setBodyRef: function (body) {
            bodyRef.current = body;
        },
        bodyLineRef: bodyLineRef,
        setBodyLineRef: function (bodyLine) {
            bodyLineRef.current = bodyLine;
        },
        dragEventHandlers: dragEventHandlers,
    };
    return (React.createElement(RowsDragContext.Provider, { value: dragContext }, React.cloneElement(table, __assign({}, props))));
}
export var DraggableTableRow = forwardRef(function (_a, ref) {
    var row = _a.row, dataKey = _a.dataKey, draggableRowKeys = _a.draggableRowKeys, props = __rest(_a, ["row", "dataKey", "draggableRowKeys"]);
    var dragEventHandlers = useContext(RowsDragContext).dragEventHandlers;
    var eventHandlers = {};
    var isDraggable = true;
    if (draggableRowKeys === "all" ||
        (draggableRowKeys &&
            Array.isArray(draggableRowKeys) &&
            draggableRowKeys.includes(dataKey))) {
        eventHandlers = dragEventHandlers;
    }
    else {
        isDraggable = false;
    }
    return React.cloneElement(row, __assign(__assign(__assign({}, props), eventHandlers), { ref: ref, draggable: isDraggable, "data-key": dataKey }));
});
export var RowsDraggableTableBody = forwardRef(function (_a, ref) {
    var body = _a.body, props = __rest(_a, ["body"]);
    var classPrefix = useConfig().classPrefix;
    var _b = useContext(RowsDragContext), setBodyRef = _b.setBodyRef, setBodyLineRef = _b.setBodyLineRef;
    return (React.createElement("div", { style: { position: "relative", overflow: "visible" } },
        React.createElement("div", { ref: setBodyLineRef, className: classPrefix + "-table__target-line--vertical", style: { display: "none" } }),
        React.cloneElement(body, __assign(__assign({}, props), { ref: mergeRefs(setBodyRef, body.ref, ref) }))));
});
RowsDraggableTable.displayName = "RowsDraggableTable";
//# sourceMappingURL=RowsDraggableTable.js.map